module.exports = __webpack_public_path__ + "img/13cabex.ee835c14.png";